import { ApiException, ErrorResponse } from "app/ApiClient";
import { tryGetValueFromJson } from "./parseHelper";

export const normalizeApiError = (error: ApiException) => {
    const { response, message } = error;
    try {
        const parsedResponse = JSON.parse(response) as ErrorResponse;
        const detailMessage = tryGetValueFromJson(parsedResponse.errorMessage ?? message, "detail");
        return new Error(detailMessage);
    }
    catch {
        // this the case where the response recived is in text format. This might happen if there are any gateway errors or any unhadled errors at server which are not captured by exception filter.
        return new Error(message);
    }
};
